import { useTranslation } from "react-i18next";
import { packageUrl } from "../../../api/knowledgeData/knowledgeDataApi";
import { PACKAGE_FORMATS, type DatasetVersionSummary } from "../../../api/knowledgeData/knowledgeDataDecoders";
import CopyReference from "../../../ui/content/CopyReference";
import ButtonLink from "../../../ui/buttons/ButtonLink";

/**
 * A release's file download (K-7): the same bytes every time. A version made before the
 * release checks downloads labelled as unchecked (D4). Kept beside ResearchSpace as
 * proposed; whether it stays is open with Johannes (F2).
 */
export default function ReleaseDownloads({ datasetId, version }: { datasetId: string; version: DatasetVersionSummary }) {
  const { t } = useTranslation();
  const checked = version.checksStatus === "pass";
  return (
    <div className="space-y-1">
      {!checked ? <p className="app-status-text-error text-sm">{t("data.releaseChecks.downloadUnchecked")}</p> : null}
      <div className="flex flex-wrap items-center gap-2">
        {PACKAGE_FORMATS.map((format) => {
          const name = t(`data.export.formats.${format}`);
          return (
            <ButtonLink key={format} href={packageUrl(datasetId, version.number, format)} download>
              {checked ? name : t("data.releaseChecks.uncheckedFormat", { format: name })}
            </ButtonLink>
          );
        })}
        <span className="app-text-muted flex items-center gap-1 text-xs">
          {t("data.export.quads", { count: version.packageQuads })}
          <CopyReference value={version.packageDigest} label={t("data.dataset.copyDigest")} />
        </span>
      </div>
    </div>
  );
}
